module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Wallet#3-9ced1ccdcbb4bc206b63caead4fb57a1.svg";